import { render, staticRenderFns } from "./mediationFiling.vue?vue&type=template&id=5a10e938&scoped=true&"
import script from "./mediationFiling.vue?vue&type=script&lang=js&"
export * from "./mediationFiling.vue?vue&type=script&lang=js&"
import style0 from "./mediationFiling.vue?vue&type=style&index=0&id=5a10e938&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a10e938",
  null
  
)

export default component.exports